<template>
    <div class="overlay_comp_wrap" v-if="isShow" style="z-index: 5;">
        <div class="overlay_comp_title">
            {{ $t('work_schedule.calendar.label_custom_time') }}
            <a class="mgl_auto" @click="action_Close"><v-icon>mdi-close</v-icon></a>
        </div>
        <div class="overlay_comp_cont" style="width: 300px;">
            <div class="form_list">
                <div class="title">{{ $t('work_schedule.calendar.label_start_time') }}</div>
                <TimePicker class="cont"
                    v-model="workRecord.startedAt"
                    :appendedClass="'input_xs'"
                />
            </div>
            <div class="form_list">
                <div class="title">{{ $t('work_schedule.calendar.label_end_time') }}</div>
                <TimePicker
                    v-model="workRecord.endedAt"
                    :appendedClass="'input_xs'"
                />
            </div>
        </div>
        <hr style="margin: 0px;">
        <div class="overlay_comp_cont button_group">
            <button class="btn btn_s btn_blue" style="width: 100%" @click="action_AddCustomWorkRecord">
                {{ $t('common.add') }}
            </button>
        </div>
    </div>
</template>


<script>
import { workerState, hideCustomTimeOverlay } from '../../../../worker-state'
const moment = require('@/util/MPMoment')

import TimePicker from '@/v2/views/Main/ShareComponents/Common/TimePickerHM.vue'

export default {
    components: { TimePicker },
    props: {
        date: Object
    },
    data() {
        return {
            worker: workerState,
            
            workRecord: {
                date: undefined,
                isCustomized: true,
                startedAt: undefined,
                endedAt: undefined,
            },
        }
    },
    watch: {
        isShow: {
            immediate: true,
            handler: function(newValue) {
                if (newValue == true) {
                    this.initCustomWorkRecord()
                    this.registESCKeyEventListener()
                }
                else {
                    this.unregistESCKeyEventListener()
                }
            }
        },
        'workRecord.startedAt': {
            handler: function(newValue) {
                if (newValue == undefined) { return }
                let s = moment(newValue)
                let e = moment(this.workRecord.endedAt)
                if (s.isSameOrAfter(e)) {
                    e = moment(s.toString())
                    e = e.add(1, 'hour')
                    this.workRecord.endedAt = e.toString()
                }
            }
        },
        'workRecord.endedAt': {
            handler: function(newValue) {
                if (newValue == undefined) { return }
                let s = moment(this.workRecord.startedAt)
                let e = moment(newValue)
                if (e.isSameOrBefore(s)) {
                    s = moment(e.toString())
                    s = s.add(-1, 'hour')
                    this.workRecord.startedAt = s.toString()
                }
            }
        }
    },
    computed: {
        isShow: function() { return this.worker.customTimeOverlay_Date == this.date }
    },
    methods: {
        action_Close() {
            hideCustomTimeOverlay()
        },
        action_AddCustomWorkRecord() {
            this.$emit('addCustomWorkRecord', this.workRecord)
            this.action_Close()
        },


        // MARK: - Private
        initCustomWorkRecord() {
            console.log('here')
            let hospitalID = this.hospital.selectedHospital._id
            this.workRecord = {
                hospitalID: hospitalID,
                workCodeID: null,
                date: this.date?.toString(),
                employees: [],
                isCustomized: true,
                startedAt: moment('2000-01-01', 'YYYY-MM-DD').set('hour', 9).set('minute', 0).toString(),
                endedAt: moment('2000-01-01', 'YYYY-MM-DD').set('hour', 18).set('minute', 0).toString(),
            }
        },


        // MARK: - EventHandle
        
        registESCKeyEventListener() {
            window.addEventListener('keydown', this.handleESCKeyEvent)
        },
        unregistESCKeyEventListener() {
            window.removeEventListener('keydown', this.handleESCKeyEvent)
        },
        handleESCKeyEvent(e) {
            let key = e.key
            if (key == 'Escape') {
                this.action_Close()
            }
        },
    }
}
</script>